<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">
					ព័ត៌មានអំពីការដាក់ប្រាក់
					<!-- <router-link :to="'/deposits/edit/' + withdraw.hash_id" v-if="withdraw.deposit_status != 'dlv'">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
					</router-link> -->
				</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដប្រតិបត្តិការ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.id).length > 0"><b>{{withdraw.id}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>វិធីដកប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.payment_type).length > 0"><b>{{withdraw.payment_type}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>គណនីធនាគារ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.account_number).length > 0"><b>{{withdraw.account_number}} {{withdraw.account_name}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ចំនួនទឹកប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.amount).length > 0"><b>{{config.moneylify(withdraw.amount)}}</b> ({{withdraw.currency}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.name).length > 0"><b>{{withdraw.username}} <md-icon class="verify" v-if="withdraw.verified == 1">verified</md-icon> ({{withdraw.name}}) ({{config.moneylify(withdraw.balance)}})</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.phone).length > 0"><b>{{withdraw.phone}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>deposit Detail</h3> -->
				<md-table>

					<md-table-row>
						<md-table-cell>ថ្ងៃដាក់ស្នើ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.created_date).length > 0"><b>{{config.datelify(withdraw.created_date)}}</b> ({{config.timelify(withdraw.created_date)}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ស្ថានភាព</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(withdraw.status).length > 0">
								<span class="error" v-if="withdraw.status == 2">{{ config.getDepositStatus(withdraw.status) }}</span>
								<span class="green" v-if="withdraw.status == 1">{{ config.getDepositStatus(withdraw.status) }}</span>
								<span class="late" v-if="withdraw.status == 0">{{ config.getDepositStatus(withdraw.status) }}</span>
							</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>អនុម័តដោយ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="withdraw.approve_by != null"><b>{{withdraw.approve_by}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃអនុម័ត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="withdraw.approved_date != null"><b>{{config.datelify(withdraw.approved_date)}}</b> ({{config.timelify(withdraw.approved_date)}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>កំណត់ចំណាំទៅកាន់អតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="withdraw.note_user != null"><b>{{withdraw.note_user}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំរបស់អ្នកគ្រប់គ្រង</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="withdraw.note_admin != null"><b>{{withdraw.note_admin}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-66">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-70 md-size-66">
						<md-field>
							<label>កំណត់ចំណាំដើម្បីបង្ហាញទៅកាន់អតិថិជន</label>
							<md-input type="text" v-model="note.note_user"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-30 md-size-33">
						<md-button class="md-raised md-primary" @click="updateNoteUser()">រក្សាទុក</md-button>
					</div>

					<div class="md-layout-item md-small-size-70 md-size-66">
						<md-field>
							<label>កំណត់ចំណាំសម្រាប់អ្នកគ្រប់គ្រង</label>
							<md-input type="text" v-model="note.note_admin"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-30 md-size-33">
						<md-button class="md-raised md-primary" @click="updateNoteAdmin()">រក្សាទុក</md-button>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="confirmWithdraw(withdraw.id)" v-if="withdraw.status == 0">យល់ព្រមដកប្រាក់</md-button>
				<md-button class="md-raised md-danger" @click="rejectWithdraw(withdraw.id)" v-if="withdraw.status == 0">បដិសេដការដកប្រាក់នេះ</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="confirmWithdrawDialog" md-title="តើអ្នកពិតជាចង់យល់ព្រមសំណើនេះមែនឬ​?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="confirmWithdraw" />
		<md-dialog-confirm :md-active.sync="rejectWithdrawDialog" md-title="តើអ្នកពិតជាចង់បដិសេដសំណើនេះមែនឬ?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="rejectWithdraw" />
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getWithdraw();
			// this.getPayment();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				confirmWithdrawDialog: false,
				rejectWithdrawDialog: false,
				confirmWithdrawId: "",
				rejectWithdrawId: "",
				withdraw: {
					id: "",
					payment_type: "",
					username: "",
					name: "",
					phone: "",
					transaction_url: "",
					created_date: "",
					approved_date: "",
					approve_by: "",
					note_user: "",
					note_admin: "",
					status: "",
					amount: 0
				},
				note: {
					note_user: "",
					note_admin: ""
				}
			}
		},
		methods: {
			getWithdraw(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/withdraw/get/" + this.$route.params.hash_id).then(data => {
					this.withdraw = data.body.data
					this.note.note_user = data.body.data.note_user
					this.note.note_admin = data.body.data.note_admin
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			confirmWithdraw(id = "") {
				if(this.$store.state.authentication.account_type == 'ad' && parseFloat(this.withdraw.amount) > 300) {
					this.$notification.notify({
						message: "សូមផ្តល់ដំណឹងទៅកាន់អ្នកគ្រប់គ្រងជាន់ខ្ពស់។",
						icon: 'error',
						type: 'danger'
					})
				} else {
					if (id == "" && String(this.confirmWithdrawId).length > 0) {
						this.$http.post(this.config.api + "/admin/withdraw/confirm", {
							withdraw_id: this.confirmWithdrawId
						}).then(data => {
							if (data.body.status == 'success') {
								this.$notification.notify({
									message: "បានយល់ព្រមដាក់ប្រាក់ដោយជោគជ័យ។",
									icon: 'done',
									type: 'success'
								})
								this.getWithdraw();
								this.onCancel();
							}
						})
					} else {
						this.confirmWithdrawId = id;
						this.confirmWithdrawDialog = true;
					}
				}


			},
			rejectWithdraw(id = "") {
				if (id == "" && String(this.rejectWithdrawId).length > 0) {
					this.$http.post(this.config.api + "/admin/withdraw/reject", {
						withdraw_id: this.rejectWithdrawId
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "បានយល់ព្រមដាក់ប្រាក់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getWithdraw();
							this.onCancel();
						}
					})
				} else {
					this.rejectWithdrawId = id;
					this.rejectWithdrawDialog = true;
				}
			},
			updateNoteUser() {
				this.$http.post(this.config.api + "/admin/withdraw/note", {
					withdraw_id: this.withdraw.id,
					type: "user",
					withdraw_note: this.note.note_user
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រតិបត្តិការត្រូវបានកែប្រែកំណត់ចំណាំទៅកាន់អតិថិជនដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getWithdraw();
						this.onCancel();
					}
				})
			},
			updateNoteAdmin() {
				this.$http.post(this.config.api + "/admin/withdraw/note", {
					withdraw_id: this.withdraw.id,
					type: "admin",
					withdraw_note: this.note.note_admin
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រតិបត្តិការត្រូវបានកែប្រែកំណត់ចំណាំទៅសម្រាប់អ្នកគ្រប់គ្រងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getWithdraw();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.confirmWithdrawDialog = false;
				this.confirmWithdrawId = "";
				this.rejectWithdrawDialog = false;
				this.rejectWithdrawId = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Withdraws/Detail.vue